function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Icon Design - Merged"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.5 3h-17a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5zM20 20H4V4h16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5 11a.498.498 0 00.354-.146l4-4-.707-.707L7.5 9.793 5.854 8.146l-.707.707 2 2A.498.498 0 007.5 11zM7.5 18a.498.498 0 00.354-.146l4-4-.707-.707L7.5 16.793l-1.646-1.647-.707.707 2 2A.498.498 0 007.5 18zM13 9h5v1h-5zM13 16h5v1h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})));